import React from 'react';
import { approveAllowance, checkAllowance } from 'src/utils/contracts/token';
import { ACTIVE_DEPLOYMENT } from 'src/utils/contracts/common';
import RegistrarDeployment from '../../contracts/deployments/Registrar.json';
import { handleError } from 'src/utils/errors/common';
import { Button } from '@mui/material';

const Allowance: React.FC<{
  cost: number;
  token: Token;
  onValueChange: (allowance: number) => void;
}> = ({ cost, token, onValueChange }) => {
  const approveTokenAllowance = async () => {
    try {
      let newAllowance = await approveAllowance(cost, token.tokenAddress);

      while (newAllowance < cost) {
        newAllowance = await checkAllowance(
          RegistrarDeployment[ACTIVE_DEPLOYMENT].address,
          token.tokenAddress,
        );
      }
      onValueChange(newAllowance);
    } catch (error) {
      handleError(error, 'Failed to approve token allowance.');
    }
  };

  return (
    <Button
      variant="contained"
      onClick={() => approveTokenAllowance()}
      sx={{
        color: 'text.primary',
        backgroundColor: 'primary.main',
        padding: '10px 16px',
      }}
    >
      Approve {cost} {token.symbol}
    </Button>
  );
};

export default React.memo(Allowance);
